(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thumbcomfort-gallery"] && !Shopify.designMode) return;
  try {
    function syncThumbComfortGallery(gallery, color, behavior) {
    const track = gallery.querySelector('.tc-gallery__track');
    if (!track) return;
    track.scrollTo({ left: (color === 'Grey' ? 2 : 0) * track.clientWidth, behavior: behavior });
  }
  function initThumbComfortGalleries() {
    document.querySelectorAll('.tc-gallery').forEach(function(gallery) {
      syncThumbComfortGallery(gallery, gallery.dataset.initialColor, 'instant');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbComfortGalleries);
  } else {
    initThumbComfortGalleries();
  }
  document.addEventListener('shopify:section:load', initThumbComfortGalleries);
  document.addEventListener('change', function(event) {
    const picker = event.target.closest('variant-selects');
    if (!picker) return;
    const container = picker.closest('section');
    const gallery = container && container.querySelector('.tc-gallery');
    const color = picker.querySelector('input[type="radio"]:checked');
    if (gallery && color) syncThumbComfortGallery(gallery, color.value, 'smooth');
  });
  } catch(e) { console.error(e); }
})();

})();
